import { Radio as AntRadio } from 'antd';
import { RadioButtonProps as AntRadioButtonProps } from 'antd/lib/radio/radioButton';

const { Button } = AntRadio;

export type RadioButtonProps = {
  // TODO
};

const RadioButton = (props: RadioButtonProps & AntRadioButtonProps) => {
  return <Button {...props} className="radio-button" />;
};

RadioButton.defaultProps = {
  autoFocus: false,
  checked: false,
  defaultChecked: false,
  disabled: false,
};

export default RadioButton;
